import { render, staticRenderFns } from "./forger-password.vue?vue&type=template&id=0c62d1e8&scoped=true&"
import script from "./forger-password.vue?vue&type=script&lang=js&"
export * from "./forger-password.vue?vue&type=script&lang=js&"
import style0 from "./forger-password.vue?vue&type=style&index=0&id=0c62d1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62d1e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VForm,VLayout,VTextField})
